import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.accountSet.query,
    method: 'post',
    data: requestBody
  })
}

// 获取详情
export function detail(requestBody) {
  return request({
    url: URL.finance.accountSet.detail,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.finance.accountSet.save,
    method: 'post',
    data: requestBody
  })
}

// 校验账套code
export function checkAccountSetCode(code) {
  return request({
    url: URL.finance.accountSet.checkAccountSetCode,
    method: 'post',
    params: { code }
  })
}

// 删除
export function remove(requestBody) {
  return request({
    url: URL.finance.accountSet.remove,
    method: 'post',
    data: requestBody
  })
}

// 从现有账套新建
export function createFromExist(requestBody) {
  return request({
    url: URL.finance.accountSet.createFromExist,
    method: 'post',
    data: requestBody
  })
}

// 保存账套相关信息
export function saveAccountSetField(requestBody) {
  return request({
    url: URL.finance.accountSet.saveAccountSetField,
    method: 'post',
    data: requestBody
  })
}
